import { render, staticRenderFns } from "./ReportDesktopGroupOrderers.vue?vue&type=template&id=665a807c"
import script from "./ReportDesktopGroupOrderers.vue?vue&type=script&lang=js"
export * from "./ReportDesktopGroupOrderers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports